import { ISearchSupplementsProps } from '@interfaces/supplements';

export const buildSearchSupplementsPayload = ({ search, page }: ISearchSupplementsProps) => ({
  pagination: {
    page,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 10,
    pageCount: 0,
    totalCount: 0,
  },
  search,
  sort: {
    active: '',
    direction: '',
  },
});
